module.exports = __webpack_public_path__ + "static/media/futariwaprecure.eea78085.png";